import { Field, Model } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { Approval, ConsumerData } from '../core/types';
import { ConsumerJsonModel } from '../consumer/consumer.json.model';
import { SubjectJsonModel } from '../subject/subject.json.model';
import { ExplanationContentJsonModel } from './content/explanation-content.json.model';

class Parts extends Model {
  @Field()
  name!: string;

  @Field()
  markdown!: string;

  @Field()
  markup!: string;

  @Field()
  _t!: string;
}

class PagesObjects extends Model {
  @Field()
  public parts!: Parts[];

  @Field()
  layout!: string;

  @Field()
  _t!: string;
}

export class Pages extends Model {
  @Field()
  pagesObjects!: PagesObjects;
}

export class ExplanationJsonModel extends JsonApiModel {
  public static override readonly type = 'explanations';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public subjectId!: string;

  @Field()
  public name!: string;

  @Field()
  topics!: string[];

  @Field()
  pages!: Pages[];

  @Field()
  config!: string; // TODO: Must later change to an object

  @Field()
  approval!: Approval;

  @Field()
  active!: boolean;

  @Field()
  version!: number;

  @Field()
  sortName!: string;

  @Field()
  public assets!: string[];

  @Field({
    parse: (value) => { return value ? new Date(value) : null; },
    serialize: (value) => { return value ? value.getTime().toString() : null; }
  })
  public updated!: Date;

  @Field()
  changedBy!: string;

  @Field()
  public consumerData!: ConsumerData;

  @Field()
  consumerId!: string;

  @Field()
  copyRestricted!: boolean;

  @Field({ toMany: ExplanationContentJsonModel })
  explanationContents!: ExplanationContentJsonModel[];

  // We do not need a relationship exercise.consumer. These getter/setters are here to assign from
  // AppState.consumers to each exerciseModel after GET
  // but do not send it back to backend on UPDATE / PATCH.
  private _consumer!: ConsumerJsonModel;
  public getConsumer(): ConsumerJsonModel { return this._consumer; }
  public setConsumer(value: ConsumerJsonModel) { this._consumer = value; }

  // Data from table competency
  private _competency!: SubjectJsonModel;
  public getCompetency(): SubjectJsonModel { return this._competency; }
  public setCompetency(value: SubjectJsonModel) { this._competency = value; }
}
